import * as React from 'react';
import { style } from 'typestyle';
import Renderer from 'src/utils/Domain/Renderer';
import { ConfigurableGridConfigItem } from 'src/components/ConfigurableGrid/ConfigurableGrid.types';

const statusClass = style({
  $debugName: 'status-icon-renderer',
  marginLeft: '5px',
  marginRight: '7px'
});

export interface StatusIconRendererParams {
  innerRenderer?: string;
  iconPosition?: 'left' | 'right';
}

export interface Params {
  value?: string;
  rendererParams?: StatusIconRendererParams;
}

export class StatusIconRenderer extends React.Component<Params> {
  constructor(props: Params) {
    super(props);
  }

  render() {
    const { value: icon, rendererParams } = this.props;
    if (icon && typeof icon === 'string') {
      const fakeTuple = icon.split(',');
      const iconElement = <i className={`${statusClass} fa-fw ${fakeTuple[0]}`} style={{ color: fakeTuple[1] }} />;

      if (rendererParams?.innerRenderer) {
        const innerText = fakeTuple[2];
        const fakeColInfo = {
          renderer: rendererParams.innerRenderer,
          classes: [],
        } as unknown as ConfigurableGridConfigItem;
        const renderedValue = Renderer.renderJustValue(innerText, fakeColInfo);
        const iconLeft = rendererParams.iconPosition === 'left';
        return (
          <span>
            {iconLeft ? iconElement : null}
            {renderedValue}
            {iconLeft ? null : iconElement}
          </span>
        );
      }

      return iconElement;
    }
    return null;
  }
}
